class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
    } else {
      console.warn('details element not found inside <details-modal>');
    }

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
      this.summaryToggle.setAttribute('role', 'button');
      this.summaryToggle.setAttribute('aria-expanded', 'false');
    } else {
      console.warn('summary element not found inside <details-modal>');
    }

    this.querySelector('button[type="button"].close')?.addEventListener(
      'click',
      this.close.bind(this)
    );
  }

  isOpen() {
    return this.detailsContainer?.hasAttribute('open') || false;
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details')?.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {    
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    
    const detailsElement = event.target.closest('details');
    if (detailsElement) {
      detailsElement.setAttribute('open', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('overflow-hidden');

      trapFocus(
        this.detailsContainer?.querySelector('[tabindex="-1"]'),
        this.detailsContainer?.querySelector('input:not([type="hidden"])')
      );
    }
  }

  close(focusToggle = true) {
    if (this.detailsContainer) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }
  }
}

customElements.define('details-modal', DetailsModal);